import { render, staticRenderFns } from "./CheckIcon.vue?vue&type=template&id=35ce670d&scoped=true&"
import script from "./CheckIcon.vue?vue&type=script&lang=ts&"
export * from "./CheckIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce670d",
  null
  
)

export default component.exports